<template>
    <div class="alert-container">
        <div :class="alertClass">
            <div class="flex">
                <div class="flex-shrink-0">
                    <!-- 图标 -->
                    <component :is="icon" class="h-5 w-5" aria-hidden="true" />
                </div>
                <div class="ml-3">
                    <h3 class="text-sm font-medium" v-html="message"></h3>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script setup>
import { ExclamationTriangleIcon, CheckCircleIcon, XCircleIcon } from '@heroicons/vue/20/solid'
import { computed, defineProps } from 'vue'

const props = defineProps({
    type: {
        type: String,
        required: true,
        default() {
            return 'success'
        }
    },
    message: {
        type: String,
        required: true,
        default() {
            return 'success'
        }
    }
})

const alertClass = computed(() => ({
    'rounded-md p-4': true,
    'bg-yellow-50 text-yellow-700': props.type === 'warning',
    'bg-red-50 text-red-700': props.type === 'error',
    'bg-green-50 text-green-800': props.type === 'success',
}))

const icon = computed(() => {
    switch (props.type) {
        case 'warning': return ExclamationTriangleIcon
        case 'error': return XCircleIcon
        case 'success': return CheckCircleIcon
        default: return CheckCircleIcon
    }
})
</script>
<style>
.alert-container {
    width: 80%;
    max-width: 40rem;
    position: fixed;
    top: 1rem;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1000;
    transition: top 0.3s ease-in-out;
}

.alert-enter {
    top: -100px;
}

.alert-enter-active {
    top: 1rem;
}
</style>
  